const theme = {
  colors: {
    background: '#FFF',
    primaryDark: '#1E3C72',
    primaryLight: '#2A5298',
    text: '#000',
  },
};

export default theme;
